import { MultiInvestment } from '@mobi/betslip/types'

export const resetMultiInvestment = (multiInvestment: MultiInvestment) => ({
  ...multiInvestment,
  value: 0,
  f1: 0,
  f2: 0,
  f3: 0,
  f4: 0,
  f5: 0,
  isBonusBet: false,
  isBonusCash: false,
  bonusBetId: null,
})
